import { useState } from 'react';
import { PqrFilters } from './filters';
import { PqrList } from './list';
import { AccountFilter } from '../../../../shared/types/modules/account';
import { LayoutModule } from '../../../layout/modules';
import { GridRowSelectionModel } from '@mui/x-data-grid';

export const Pqr = () => {
    const [filters, setFilters] = useState<AccountFilter>();
    const [selectionModel, setSelectionModel] = useState<GridRowSelectionModel>(
        []
    );

    return (
        <>
            <LayoutModule title="Búsqueda de casos PQR">
                <PqrFilters
                    onFilter={(filters) => setFilters(filters)}
                    selectionModel={selectionModel}
                />
            </LayoutModule>
            <PqrList
                filters={filters}
                onSelectionModel={(selectionModel) =>
                    setSelectionModel(selectionModel)
                }
            />
        </>
    );
};
